import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientService } from '../../preview/invoices/services/client.service';
import { TrialContactForm } from '../../preview/models/trialContactForm.model';
import { TrialDialogData } from '../../preview/models/trialDialogContactData.model';

@Component({
  selector: 'app-trial-contact-dialog',
  templateUrl: './trial-contact-dialog.component.html',
  styleUrls: ['./trial-contact-dialog.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TrialContactDialogComponent implements OnInit {
  contactForm!: FormGroup;
  isContactFormSent:boolean = false;
  isLoading:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TrialContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TrialDialogData,
    private clientService: ClientService
  ) {
    this.contactForm = this.formBuilder.group({
      phone: ['', [Validators.required, Validators.minLength(9)]],
      email: ['', [Validators.required, Validators.email]],
      message: [''],
    });
  }

  async ngOnInit() {
    let userInfo: any = localStorage.getItem('userInfo');
    userInfo = JSON.parse(userInfo);
    this.contactForm.controls['phone'].setValue(userInfo.phone);
    this.contactForm.controls['email'].setValue(userInfo.email);
  }

  onSubmit() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    let contactForm1: TrialContactForm = {
      email: this.contactForm.get('email')?.value,
      phoneNumber: this.contactForm.get('phone')?.value,
    };
    if (this.contactForm.get('message')?.value) {
      contactForm1['message'] = this.contactForm.get('message')?.value;
    }
    this.clientService
      .ContactForm(contactForm1)
      .then((res) => {
        this.isLoading = false;
        this.isContactFormSent = true;
      })
      .catch((err) => {
        this.isLoading = false;
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
